module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book-detail"
  }, [_c('div', {
    staticClass: "content-nav-wrapper"
  }, [_c('div', {
    staticClass: "title-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('comb.copyrightWorkManagement')))]), _vm._v(" "), _c('span', [_vm._v("作品详情")])])]), _vm._v(" "), _c('el-row', {
    staticClass: "base-content"
  }, [(_vm.book.coverImg) ? _c('img', {
    staticClass: "cover-img",
    attrs: {
      "src": ("" + _vm.UPLOAD_IMG_HOST + (_vm.book.coverImg))
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('el-row', [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.book.title))])]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "inner-label"
  }, [_vm._v(_vm._s(_vm.$t('comb.workType')))]), _c('span', [_vm._v(" " + _vm._s(_vm.book.categoryLabel))])]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "inner-label"
  }, [_vm._v("I S B N")]), _c('span', [_vm._v(" " + _vm._s(_vm.book.isbn))])]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "inner-label"
  }, [_vm._v(_vm._s(_vm.$t('word.publisher')))]), _c('span', [_vm._v(" " + _vm._s(_vm.book.publishCompany))])]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "inner-label",
    staticStyle: {
      "display": "inline"
    }
  }, [_vm._v(_vm._s(_vm.$t('comb.workIntro')))]), _vm._v(" "), _c('el-tooltip', {
    attrs: {
      "content": _vm.book.intro,
      "placement": "top",
      "popper-class": "desc-popper"
    }
  }, [_c('span', {
    staticClass: "one-line-desc"
  }, [_vm._v("\n                        " + _vm._s(_vm.book.intro) + "\n                    ")])])], 1)], 1)]), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('comb.workAttachment')))]), _vm._v(" "), _vm._l((_vm.book.attachmentList), function(attachment) {
    return _c('div', {
      staticClass: "attachment-wrapper"
    }, [_c('span', {
      staticClass: "attachment-name"
    }, [_vm._v(_vm._s(attachment.fileName))]), _vm._v(" "), _c('a', {
      staticClass: "download",
      attrs: {
        "href": (_vm.UPLOAD_IMG_HOST + "/" + (attachment.fileUrl)),
        "download": "attachment"
      }
    }, [_vm._v("下载")])])
  })], 2), _vm._v(" "), _c('el-row', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('comb.copyrightInfo')))]), _vm._v(" "), (_vm.book.bookContract && _vm.book.bookContract.exclusive) ? _c('p', {
    staticClass: "copyright-info"
  }, [_vm._v("有声化后独家授权喜马拉雅FM使用")]) : _c('p', {
    staticClass: "copyright-info"
  }, [_vm._v("有声化后授权喜马拉雅FM使用")])]), _vm._v(" "), (_vm.book.status === 5) ? _c('el-row', [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.$t('comb.AuditResult')))]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('span', [_vm._v("拒绝原因：" + _vm._s(_vm.book.bookApply.auditRemark))])]), _vm._v(" "), _c('p', {
    staticClass: "intro"
  }, [_c('span', [_vm._v("审核时间：" + _vm._s(_vm.getFormatTime(_vm.book.bookApply.lastUpdateTime)))])])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-1903ad87!./~/vue-loader/lib/selector.js?type=template&index=0!./views/copyrighter/center/BookDetail.vue
// module id = 1024
// module chunks = 0